import { typeChecker } from './typeChecker';


// 可用語言，全小寫
const validLanguages = ['zh-tw', 'en', 'zh-cn', 'ja'];

// 給定語言在可用清單內則傳回轉小寫後的可用語系名稱，反之為false
export default function (lang) {
	const type = typeChecker(lang);

	if (type === 'String') lang = lang.toLocaleLowerCase();
	else return false;

	return validLanguages.indexOf(lang) === -1 ? false : lang;
};


// WEBPACK FOOTER //
// ./src/commonJS/languageVerifier.js